import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback, useRef, useState } from 'react';
import { ResizeDetector } from '@/components/functional/Resize/ResizeDetector';
import { RfpProfessionalPJDateTag } from '@/components/modules/pages/rfp/professional/Tag/RfpProfessionalPJDateTag';
import { CaretDownIcon, CaretRightIcon, } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
/**
 * コンサルタント：PJ開始/終了日時をまとめて表示するためのコンポーネント
 * @param props
 * @constructor
 */
export const RfpProfessionalPJDateGroupTag = (props) => {
    const { className = '', endDate, isNegotiableEndDate, isNegotiableStartDate, startDate, } = props;
    /** 要素の折り返しが必要か */
    const [isBreakLine, changeIsBreakLine] = useState(false);
    /** ラッパー要素の動的className */
    const [stateClassName, changeStateClassName] = useState('');
    const wrapperRef = useRef(null);
    const startDateRef = useRef(null);
    const endDateRef = useRef(null);
    const iconRef = useRef(null);
    /**
     * リサイズ時の親要素幅に応じて、折り返し表示を制御する
     */
    const onResize = useCallback((width) => {
        if (!startDateRef.current ||
            !endDateRef.current ||
            !iconRef.current ||
            width === undefined) {
            return;
        }
        // 内部要素のwidthを計算
        const { offsetWidth: startDateWidth } = startDateRef.current;
        const { offsetWidth: endDateWidth } = endDateRef.current;
        const { offsetWidth: iconWidth } = iconRef.current;
        /** 内部要素が親要素の幅を上回っているか */
        const isOverflow = width < startDateWidth + endDateWidth + iconWidth;
        changeIsBreakLine(isOverflow);
        changeStateClassName(isOverflow ? 'flex-col items-start' : 'items-center');
    }, [startDateRef, endDateRef, iconRef]);
    if (!startDateRef.current || !endDateRef.current || !iconRef.current) {
        return null;
    }
    return (_jsx(ResizeDetector, Object.assign({ onResize: onResize, targetRef: wrapperRef }, { children: _jsxs("div", Object.assign({ className: clsx('flex flex-wrap', stateClassName, className), ref: wrapperRef }, { children: [_jsx(RfpProfessionalPJDateTag, { date: startDate, isNegotiable: isNegotiableStartDate, tagRef: startDateRef, titleText: 'PJ開始時期' }), _jsx("span", Object.assign({ className: 'leading-[0]', ref: iconRef }, { children: isBreakLine ? (_jsx(CaretDownIcon, { className: 'ml-12', color: 'inactive', size: 'sm' })) : (_jsx(CaretRightIcon, { color: 'inactive', size: 'sm' })) })), _jsx(RfpProfessionalPJDateTag, { date: endDate, isNegotiable: isNegotiableEndDate, tagRef: endDateRef, titleText: 'PJ完了時期' })] })) })));
};
